export default __webpack_public_path__ + "static/branding-assets-in-one-place-2402b92d292a424068a8500e66445066.png";